import classnames from 'classnames'

import { transformImageSrc } from '@src/quince-components/src/atoms/image/image.utils'

import { OptionContainer } from '../option-container/option-container'
import { OptionProp } from '../OptionSelector.constant'

import styles from './imageOption.module.scss'

const getOptionImageURL = (imgURL: string) => {
  imgURL = transformImageSrc(imgURL)
  const imageURL = new URL(imgURL.startsWith('http') ? imgURL : `https:${imgURL}`)
  /* eslint-disable i18next/no-literal-string -- URL query params for image resize, not user-facing */
  imageURL.searchParams.append('w', '48')
  imageURL.searchParams.append('h', '48')
  imageURL.searchParams.append('fm', 'webp')
  /* eslint-enable i18next/no-literal-string */
  return imageURL.toString()
}

type ImageOptionProps = {
  value: string
  displayName?: string
  imgURL?: string | null
  disabled?: boolean
  onChange?: (value: string) => void
  showRedDot?: boolean
} & Pick<OptionProp, 'isSelected' | 'isRound' | 'selectionSetId' | 'className'>

export const ImageOption = ({
  value,
  displayName,
  imgURL,
  isSelected,
  isRound,
  disabled,
  className,
  selectionSetId,
  onChange,
  showRedDot,
}: ImageOptionProps) => {
  return (
    <div className={classnames(styles.imageOptionWrapper)}>
      <OptionContainer
        value={value}
        displayName={displayName}
        selectionSetId={selectionSetId}
        isSelected={isSelected}
        srOnly
        disabled={disabled}
        inputClassName={styles.input}
        labelClassName={classnames(className, styles.label, {
          [styles.isRound]: isRound,
        })}
        onChange={onChange}
      >
        <img
          className={classnames(styles.image)}
          src={imgURL ? getOptionImageURL(imgURL) : undefined}
          role="presentation"
        />
      </OptionContainer>
      {showRedDot && <div className={classnames(styles.redDot)} />}
    </div>
  )
}

const ImageOptionWithOptionValue = ({ optionValue, ...props }: OptionProp) => {
  return (
    <ImageOption
      value={optionValue.value}
      displayName={optionValue.displayName}
      imgURL={optionValue.imgURL}
      {...props}
    />
  )
}

export default ImageOptionWithOptionValue
